import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AlertService } from 'services/alert.service';
import { ApplicationService } from 'services/application.service';
import { ZoomactivatepopupComponent } from '../zoomactivatepopup/zoomactivatepopup.component';

@Component({
  selector: 'app-managecommunication',
  templateUrl: './managecommunication.component.html',
  styleUrls: ['./managecommunication.component.scss']
})
export class ManagecommunicationComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  form: FormGroup;
  confirmTermAndCondition: [];
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "customerNumber",
    "customerName",
    "mobileNumber",
    "Email",
    "Address",

  ];
  titleList = [
    { id: 1, value: "Vumatel" },
    { id: 2, value: "Zoom", },
    { id: 3, value: "OpenServe", }
  ];

  province = [
    { value: 'Western Cape', id: 1 },
    { value: 'Eastern Cape', id: 2 },
    { value: 'Free State', id: 3 },
    { value: 'Kwa-Zulu-Natal', id: 4 },
    { value: 'Limpopo', id: 5 },
    { value: 'Mpumalanga', id: 6 },
    { value: 'North West', id: 7 },
    { value: 'Northern Cape', id: 8 },
    { value: 'Gauteng', id: 9 },

  ]
  list: any;
  result: any;
  openmessage: boolean = false;
  datacount: boolean;
  suberror: boolean = false;
  conterror: boolean = false;
  empty: any[];

  constructor(private formBuilder: FormBuilder, private applicationService: ApplicationService, public dialog: MatDialog,
    public alertService: AlertService) { }

  ngOnInit() {
    this.initializeValidators();
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      service: ['', Validators.required],
      // status: ["Service/Voucher Activated"],
      province: ['', Validators.required],
      city: [''],
      // subject : [''],
      // content : ['']
    });
  }

  load() {
    debugger;
    console.log(this.form.value);
    if (this.form.valid) {
      this.applicationService.searchCommunication(this.form.value).subscribe(res => {
        if (res != null && res.length > 0) {
          this.list = res;
          this.dataSource = new MatTableDataSource(this.list);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.datacount = true;
        }
        else {
          this.datacount = false;
          this.dataSource = new MatTableDataSource(res);
        }
      })
    }
    else {
      this.validateFormControl();
    }
  }
  onServiceSelect(id) {

  }

  onProvinceSelect(id) {

  }

  next() {
    // this.openmessage = true;
    const dialogRef = this.dialog.open(ZoomactivatepopupComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        commPage: true
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.content != '' && data != true) {
        this.send(data.content)
      }
      else if (data == true) {

      }
    });
  }
  send(content) {
    debugger
    var datas = {
      service: this.form.value.service,
      province: this.form.value.province,
      city: this.form.value.city,
      content: content,
      token: 1
    }

    this.applicationService.searchCommunication(datas).subscribe(res => {
      this.result = res;
      if (this.result != null) {
        this.dataSource = new MatTableDataSource(this.result);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        if (this.result[0].saveData == true) {
          this.alertService.success("Message Sent");
        }
        else {
          this.alertService.error("Something went wrong!");
        }
      }
      else {
        this.dataSource = new MatTableDataSource(this.result);
        this.datacount = false;
      }
    })

  }

  refresh() {
    this.empty = [];
    this.datacount = false;
    this.dataSource = new MatTableDataSource(this.empty);
    this.initializeValidators();
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }


}
